import React, { useState, useEffect } from 'react';
import styles from './japan-cherry-blossom-trails.module.css';
import PromoSidebar from '../../../PromoSidebar/PromoSidebar';
import BlogNavigator from '../../../BlogNavigator/BlogNavigator';
import { travelBlogs } from '../Travelinternational';
import FAQSection from '../../../../Contact/FAQSection';

import heroImg from './Mt. Fuji.webp';
import cityImg from './tokyo-tower-825196_640.webp';
import foodImg from './food.webp';
import onsenImg from './Onsen Hot Springs.webp';
import gallery1 from './Anime Culture.webp';
import gallery2 from './Chidorigafuchi.webp';
import gallery3 from './Ghibli Museum.webp';
import gallery4 from './Hirosaki Castle Park.webp';
import gallery5 from './Kimono Wearing.webp';
import gallery6 from './Shrines & Temples.webp';
import gallery7 from './temple-6683242_640.webp';
import gallery8 from './Theme Parks & Digital Experiences.webp';
import gallery9 from './Shibuya Crossing.webp';
import Spring from './Cherry Blossom Hotspots.webp';
import Summer from './Hirosaki Castle Park.webp';
import Autumn from './Autumn — Vibrant Red & Gold Foliage.webp';
import Winter from './Winter — Snow Adventures & Festive Charm.webp';
import Tokyo from './tokyo-tower-825196_640.webp';
import Kyoto from './Kyoto.webp';
import Osaka from './osaka-castle-2404524_1280.webp';
import Nara from './Nara.webp';
import Hiroshima from './Hiroshima.webp';
import Sapporo from './Sapporo.webp';
import Fukuoka from './Fukuoka.webp';
import Nagoya from './nagoya-city-84007_640.webp';
import Fuji from './Mt. Fuji.webp';
import Fushimi from './Temple Strolls.webp';
import TeamLab from './Tokyo Skytree.webp';
import Blossoms from './japanese-cherry-blossom-2168858_640 (1).webp';
import Bullet from './train.webp';
import Kimono from './akihabara-8143130_640.webp';
import Onsen from './Onsen Hot Springs.webp';
import Akihabara from './Gaming & Pop Culture.webp';
import anime1 from './Themed Cafés.webp';
import anime2 from './animethemecafe.webp';
import anime3 from './Anime Culture.webp';
import anime4 from './bullettrain.webp';
import cars1 from './cars1.webp';
import cars2 from './cars2.webp';
import cars3 from './cars3.webp';
import cars4 from './cars4.webp';


export default function JapanFullBlog() {

const seasonsData = [
  {
    title: "Spring — Cherry Blossom Magic (March to Early April)",
    content:
      "Spring in Japan is synonymous with cherry blossoms (sakura) and hanami festivals. Late March to early April offers breathtaking blooms across parks, riversides, and temples.",
    img: Spring
  },
  {
    title: "Summer — Festivals & Outdoor Adventures (June to August)",
    content:
      "Summer features lively festivals and fireworks. Despite the heat, it’s great for beaches, hikes, and cultural experiences across Japan.",
    img: Summer
  },
  {
    title: "Autumn — Vibrant Red & Gold Foliage (October to November)",
    content:
      "Autumn paints Japan in fiery reds, oranges, and golds. Ideal for temples, gardens, and mountain landscapes with cool weather and stunning photo spots.",
    img: Autumn
  },
  {
    title: "Winter — Snow Adventures & Festive Charm (December to February)",
    content:
      "Winter transforms Japan into a snowy wonderland — perfect for skiing in Hokkaido, winter festivals, and relaxing natural hot springs (onsen).",
    img: Winter
  },
];
const [openIndex, setOpenIndex] = React.useState(null);

const handleToggle = (i) => {
  setOpenIndex(openIndex === i ? null : i);
};


const citiesData = [
  {
    title: "Tokyo",
    img: Tokyo,
    content: "Japan’s capital — vibrant districts (Shibuya, Shinjuku), museums, pop-culture and amazing food."
  },
  {
    title: "Kyoto",
    img: Kyoto,
    content: "Ancient capital with temples, geisha districts and classical gardens."
  },
  {
    title: "Osaka",
    img: Osaka,
    content: "Food capital with lively street scenes and Universal Studios Japan."
  },
  {
    title: "Nara",
    img: Nara,
    content: "Home to friendly deer and historic temples — perfect for day trips from Kyoto."
  },
  {
    title: "Hiroshima",
    img: Hiroshima,
    content: "Peace Memorial Park & Miyajima island nearby."
  },
  {
    title: "Sapporo",
    img: Sapporo,
    content: "Northern city famous for winter festivals and seafood."
  },
  {
  title: "Fukuoka",
  img: Fukuoka,
  content: "Gateway to Kyushu — known for beaches, modern shopping hubs and the famous Hakata ramen."
},
{
  title: "Nagoya",
  img: Nagoya,
  content: "Industrial and cultural hub with Nagoya Castle, Toyota museum and great local food spots."
}
];

const [openCity, setOpenCity] = useState(null);


const attractionImages = [
  { id: 1,     img: Fuji, alt: "Mount Fuji" },
  { id: 2,     img: Fushimi, alt: "Fushimi Inari Shrine" },
  { id: 3,    img: TeamLab, alt: "TeamLab Tokyo" },
  { id: 4,    img: Blossoms, alt: "Cherry Blossoms" }
];
const [slide, setSlide] = useState(0);

useEffect(() => {
  const timer = setInterval(() => {
    setSlide(prev => (prev + 1) % attractionImages.length);
  }, 3000);

  return () => clearInterval(timer);
}, []);

const experienceImages = [
  { id: 1, img: Bullet, alt: "Bullet Train - Shinkansen" },
  { id: 2, img: Kimono, alt: "Kimono Walking Experience" },
  { id: 3, img: Onsen, alt: "Japanese Onsen Hot Springs" },
  { id: 4, img: Akihabara, alt: "Anime & Gaming - Akihabara" }
];

const animeImages = [
  { id: 1, img: anime1, alt: "Akihabara Street" },
  { id: 2, img: anime2, alt: "Ghibli Museum" },
  { id: 3, img: anime3, alt: "Themed Anime Café" },
  { id: 4, img: anime4, alt: "Anime Event & Cosplay" }
];



  const navItems = [
    { id: 'intro', label: "Japan Travel Overview: Must-Know Facts & Highlights" },
    { id: 'top-dest', label: 'Top Reasons to Visit Japan in 2025' },
    { id: 'best-time', label: 'Best Time to Visit Japan: Seasons & Festivals Guide' },
    { id: 'cities', label: 'Explore Japan’s Top Cities: Kyoto, Tokyo & Beyond' },
    { id: 'attractions', label: 'Must-See Attractions in Japan: Temples, Parks & Landmarks' },
    { id: 'experiences', label: 'Unforgettable Experiences Only in Japan' },
    { id: 'food', label: 'Japan Food Guide: Traditional Eats & Street Food' },
    { id: 'culture', label: 'Japanese Culture & Etiquette: Tips for Travelers' },
    { id: 'tips', label: 'Essential Travel Tips for Japan Visitors' },
    { id: 'budget', label: 'Japan Travel Budget Guide: Costs & Saving Tips' },
    { id: 'itineraries', label: 'Perfect Japan Itineraries for 3, 5 & 7 Days' },
    { id: 'anime', label: 'Anime & Pop Culture Hotspots in Japan' },
    { id: 'why-us', label: 'Why Book Your Japan Trip With Atlas Travel House' },
    { id: 'faq', label: 'Japan Travel FAQs: Everything You Need to Know' },
];


 const faqData = [
  { 
    question: 'Do I need a visa for Japan?', 
    answer: 'Visa requirements depend on your nationality. Many countries have visa exemptions for short-term tourism, but always check the official Japanese embassy website and allow enough time for visa processing if required.' 
  },
  { 
    question: 'Is English widely spoken in Japan?', 
    answer: 'Basic English is available in major cities, tourist attractions, and hotels, but outside urban areas, knowledge of Japanese is limited. Learning a few key phrases or using translation apps can enhance your travel experience.' 
  },
  { 
    question: 'Are credit/debit cards widely accepted?', 
    answer: 'Cards are accepted in most hotels, restaurants, and shops in major cities. However, small shops, rural areas, temples, and train kiosks often prefer cash, so carry Japanese yen (¥).' 
  },
  { 
    question: 'What are the best SIM/Wi-Fi options in Japan?', 
    answer: 'For connectivity, consider prepaid tourist SIM cards or pocket Wi-Fi devices, available at airports or via pre-booking online. They provide reliable internet for navigation, translation, and social sharing.' 
  },
  { 
    question: 'What is the best time to visit Japan?', 
    answer: 'Spring (March–May) offers cherry blossoms, autumn (October–November) has stunning foliage, summer (June–August) features festivals and fireworks, and winter (December–February) is ideal for skiing and hot springs.' 
  },
  { 
    question: 'How do I get around Japan?', 
    answer: 'Japan has an extensive transport network including Shinkansen bullet trains, local trains, buses, and taxis. Using IC cards like Suica or Pasmo makes city travel seamless, and JR Passes save money on long-distance journeys.' 
  },
  { 
    question: 'What are must-try Japanese foods?', 
    answer: 'Don’t miss sushi, ramen, tempura, okonomiyaki, takoyaki, and matcha desserts. Vegetarians can enjoy shojin ryori (temple cuisine) and vegetable dishes in specialty restaurants.' 
  },
  { 
    question: 'Are Japan’s attractions family-friendly?', 
    answer: 'Yes, many attractions cater to families, including theme parks, aquariums, and interactive museums. Plan a slower pace with kid-friendly activities for a comfortable trip.' 
  },
  { 
    question: 'What cultural etiquette should I follow?', 
    answer: 'Respect local customs: bow politely, remove shoes in homes/temples, avoid loud talking on trains, follow temple rules, and use proper chopstick etiquette. These enhance your travel experience and respect for Japanese culture.' 
  },
  { 
    question: 'Is Japan safe for solo travelers?', 
    answer: 'Japan is extremely safe with low crime rates. Solo travelers can enjoy capsule hotels, easy public transport, and guided tours. Staying aware of local customs and etiquette ensures a smooth experience.' 
  },
  { 
    question: 'Can I visit multiple cities in a short trip?', 
    answer: 'Yes, Japan’s Shinkansen network allows easy day trips and multi-city travel. Popular short itineraries include Tokyo–Hakone, Kyoto–Nara, and Osaka–Kyoto, ensuring you experience culture, nature, and urban life.' 
  },
  { 
    question: 'How much cash should I carry?', 
    answer: 'While urban areas accept cards, carrying 10,000–20,000 yen per person is recommended for daily expenses, small shops, vending machines, temples, and rural destinations.' 
  }
];


  const promoOffers = [
    {
      id: 1,
      title: '🌸 Sakura Season Special',
      desc: 'Custom sakura itineraries with local guides & skip-the-line options.',
      btn: 'Enquire Now',
      images: [Spring],
    },
  ];

  return (
    <article className={styles.page}>
      <header className={styles.hero} id="intro">
        <img src={heroImg} alt="Japan travel hero" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.title}>Japan — Complete Travel Guide</h1>
          <p className={styles.subtitle}>Cherry blossoms, neon cities, peaceful temples, epic food — everything you need to plan an unforgettable Japan trip.</p>
        </div>
      </header>

      <div className={styles.layoutGrid}>
        <aside className={styles.leftSidebar}>
          <nav className={styles.nav} aria-label="On this page">
            <h5>On this page  - Quick Links</h5>
            <ul>
              {navItems.map(item => (
                <li key={item.id}><a href={`#${item.id}`}>{item.label}</a></li>
              ))}
            </ul>
          </nav>
        </aside>

          <main className={styles.content}>
          <section id="top-dest" className={styles.block}>
  <h2>Why Japan is a Must-Visit Travel Destination in 2025</h2>
  <p>
    Japan is a mesmerizing blend of futuristic cities, timeless traditions, breathtaking landscapes, and a world-renowned culinary scene. From the neon-lit streets of Tokyo to the tranquil temples of Kyoto, and from snow-capped mountains to cherry blossom-filled gardens, Japan offers experiences that cater to every type of traveler.
  </p>
  <div className={styles.rowTwo}>
    <img src={cityImg} alt="Tokyo and Kyoto travel highlights" className={styles.inlineImg} />
   <ul>
  <li>Extremely safe, immaculately clean, and easy to explore for tourists.</li>
  <li>Authentic cultural experiences, from traditional tea ceremonies to vibrant local festivals.</li>
  <li>World-class public transport seamlessly connecting cities, towns, and scenic spots.</li>
  <li>Breathtaking natural landscapes, including cherry blossoms, Mount Fuji, and serene gardens.</li>
  <li>Renowned culinary delights, from sushi and ramen to street food and Michelin-starred restaurants.</li>
  <li>Unique pop culture experiences, including anime hubs, themed cafés, and gaming districts.</li>
  <li>Rich history and heritage, with castles, shrines, and UNESCO World Heritage sites.</li>
</ul>

  </div>
  <p>
    Whether you’re seeking thrilling city adventures, peaceful nature escapes, or a culinary journey like no other, Japan promises memories that last a lifetime.
  </p>
</section>

<section id="best-time" className={styles.block}>
  <h2>Best Time to Visit Japan: Seasonal Travel Guide</h2>
  <div className={styles.gridThree}>
    {seasonsData.map((season, i) => (
      <article key={i} className={styles.seasonCard}>
        {openIndex !== i && (
          <div className={styles.seasonImgWrap}>
            <img src={season.img} alt={season.title} />
            <button className={styles.tapBtn} onClick={() => handleToggle(i)}>Expand </button>
          </div>   )}   
        {openIndex === i && (
          <div className={styles.seasonText}>
            <h3>{season.title}</h3>
            <p>{season.content}</p>
            <button   className={styles.tapBtn}    onClick={() => handleToggle(i)} >Back </button>
          </div> )}
      </article>  ))}
  </div>
</section>


          <section id="cities" className={styles.block}>
  <h2>Top Cities Overview</h2>

  <div className={styles.gridThree}>
    {citiesData.map((city, i) => (
      <article key={i} className={styles.seasonCard}>
        
        {openCity !== i && (
          <div className={styles.seasonImgWrap}>
            <img src={city.img} alt={city.title} />
            <button 
              className={styles.tapBtn}
              onClick={() => setOpenCity(i)}
            >
Expand            </button>
          </div>
        )}

        {openCity === i && (
          <div className={styles.seasonText}>
            <h3>{city.title}</h3>
            <p>{city.content}</p>
            <button 
              className={styles.tapBtn}
              onClick={() => setOpenCity(null)}
            >
              Back
            </button>
          </div>
        )}

      </article>
    ))}
  </div>
</section>


        

<section id="attractions" className={styles.block}>
    <h2>Must-See Attractions in Japan: Top Travel Highlights</h2>

  <div className={styles.carousel}>
    {attractionImages.map((item, i) => (
      <img 
        key={item.id}
        src={item.img}
        alt={item.alt}
        className={`${styles.slide} ${slide === i ? styles.active : ""}`}
      />
    ))}
  </div>


  <ul className={styles.attractionList}>
    <li>
      <strong>Shrines & Temples:</strong> Explore iconic spiritual sites like Fushimi Inari Taisha in Kyoto, Tokyo’s historic Senso-ji Temple, and the golden Kinkaku-ji Temple.
    </li>

    <li>
      <strong>Mt. Fuji:</strong> Japan’s most iconic mountain with breathtaking views and day-trip options.
    </li>

    <li>
      <strong>Theme Parks & Digital Experiences:</strong> Universal Studios Japan + TeamLab Planets Tokyo.
    </li>

    <li>
      <strong>Tokyo Landmarks:</strong> Skytree, Shibuya Crossing, and vibrant districts.
    </li>

    <li>
      <strong>Cherry Blossom Hotspots:</strong> Kyoto’s Philosopher’s Path, Chidorigafuchi, Hirosaki Castle Park.
    </li>
  </ul>

  <p>
    From historic temples and majestic mountains to modern theme parks and iconic cityscapes, Japan offers unforgettable travel experiences.
  </p>
</section>

         
<section id="experiences" className={styles.block}>
  <h2>Unmissable Experiences in Japan: Cultural & Modern Adventures</h2>
  <div className={styles.carousel}>
    {experienceImages.map((item, i) => (
      <img
        key={item.id}
        src={item.img}
        alt={item.alt}
        className={`${styles.slide} ${slide === i ? styles.active : ""}`}
      />
    ))}
  </div>

  <ol className={styles.experienceList}>
    <li>
      <strong>Shinkansen Bullet Train:</strong> Experience Japan’s legendary high-speed rail system. Fast, punctual, and ultra-comfortable, traveling by Shinkansen offers scenic views of cities, Mount Fuji, and countryside landscapes — a must for every Japan traveler.
    </li>

    <li>
      <strong>Kimono Wearing & Temple Strolls:</strong> Rent a traditional kimono and wander through Kyoto or Nara’s historic temple districts. Perfect for immersive cultural experiences and stunning photography.
    </li>

    <li>
      <strong>Onsen Hot Springs:</strong> Relax in traditional Japanese hot springs while following local etiquette. Enjoy serene mountain views, therapeutic waters, and the ultimate rejuvenating experience.
    </li>

    <li>
      <strong>Anime, Gaming & Pop Culture:</strong> Dive into Tokyo’s Akihabara district, visit Pokémon Centers, themed cafés, and gaming arcades. A must for anime fans and pop culture enthusiasts looking for unique, interactive experiences.
    </li>
  </ol>

  <p>
    From futuristic bullet trains and pop culture adventures to ancient traditions and soothing hot springs, Japan offers experiences that create unforgettable memories for every traveler.
  </p>
</section>

      <section id="food" className={styles.block}>
  <h2>Japan Food Guide: Must-Try Dishes & Culinary Tips</h2>
  <div className={styles.rowTwo}>
    <img src={foodImg} alt="Authentic Japanese cuisine" className={styles.inlineImg} />
    <div>
      <h4>Must-Try Japanese Dishes</h4>
      <p>
        Savor Japan’s culinary delights, including fresh sushi, flavorful ramen, crispy tempura, and traditional matcha desserts. Don’t miss local street foods like takoyaki, okonomiyaki, and yakitori for an authentic foodie adventure.
      </p>
      <h4>Vegetarian & Special Diet Options</h4>
      <p>
        Many restaurants across Japan cater to vegetarian and vegan diets. Explore temple cuisine (shojin ryori) or specialty shops offering seasonal vegetable dishes, tofu, and plant-based delicacies.
      </p>
      <h4>Dining Etiquette Tips</h4>
      <p>
        Respect Japanese dining customs: never stick chopsticks upright in rice, use both hands when offering dishes, and enjoy slurping noodles — it’s a sign of appreciation! Being mindful of these traditions enhances your culinary experience.
      </p>
    </div>
  </div>
  <p>
    From street snacks to gourmet meals, Japan offers a diverse food journey that combines tradition, innovation, and unforgettable flavors — making it a paradise for every traveler and food lover.
  </p>
</section>


          

        <section id="culture" className={styles.block}>
  <h2>Japanese Culture & Etiquette: Essential Tips for Travelers</h2>
  <ul>
    <li>
      <strong>Do’s:</strong> Show respect with polite bows, remove shoes when entering homes or temples, and always queue patiently for trains and buses.
    </li>
    <li>
      <strong>Don’ts:</strong> Avoid loud conversations on public transport, refrain from eating while walking in traditional neighborhoods, and respect local customs at shrines and temples.
    </li>
    <li>
      <strong>Train Etiquette:</strong> Priority seats are reserved for the elderly, disabled, and pregnant travelers. Keep phones on silent, and avoid phone calls inside carriages to maintain a peaceful environment.
    </li>
    <li>
      <strong>Cash vs Card:</strong> While major cities accept credit cards, carry cash (¥) for smaller shops, street vendors, rural areas, and local markets where card payments may not be available.
    </li>
    <li>
      <strong>General Cultural Tips:</strong> Always show respect in temples and shrines, be mindful of photography restrictions, and embrace local customs to make your travel experience authentic and memorable.
    </li>
  </ul>
  <p>
    Understanding and following Japanese etiquette not only helps you blend in smoothly but also enriches your travel experience, allowing you to connect with the culture and people on a deeper level.
  </p>
</section>


         <section id="tips" className={styles.block}>
  <h2>Essential Japan Travel Tips for a Smooth Trip</h2>
  <ul>
    <li>
      <strong>Advance Booking:</strong> Reserve flights and accommodations 3–6 months ahead, especially during peak seasons like cherry blossom (March-April) and autumn foliage (October-November) to secure the best deals.
    </li>
    <li>
      <strong>Japan Rail (JR) Pass:</strong> Ideal for long-distance travel across Japan. Purchase before arrival to save on bullet train (Shinkansen) and regional train costs.
    </li>
    <li>
      <strong>City Travel Cards:</strong> Use IC cards like Suica or Pasmo for seamless access to trains, buses, and even convenience store purchases in major cities like Tokyo and Osaka.
    </li>
    <li>
      <strong>SIM & Wi-Fi Connectivity:</strong> Stay connected with local SIM cards or pre-book pocket Wi-Fi at airports. Essential for navigation, translation, and sharing your travel moments.
    </li>
    <li>
      <strong>Luggage & Packing:</strong> Travel light if moving between multiple cities. Coin lockers at stations are convenient for temporary storage. Don’t forget adapters for electronics and season-appropriate clothing.
    </li>
    <li>
      <strong>Language & Communication:</strong> Learn basic Japanese phrases and use translation apps. Many locals speak limited English, so politeness and gestures go a long way.
    </li>
    <li>
      <strong>Cash & Payments:</strong> Carry some cash (¥) as small shops, temples, and rural areas may not accept cards. ATMs at 7-Eleven or post offices are reliable.
    </li>
    <li>
      <strong>Respect Local Customs:</strong> Follow etiquette in temples, on trains, and during festivals. Observing local rules ensures a smooth and respectful travel experience.
    </li>
  </ul>
  <p>
    Following these practical tips helps you navigate Japan efficiently, enjoy authentic experiences, and avoid common travel hassles, making your trip smooth and memorable.
  </p>
</section>


        <section id="budget" className={styles.block}>
  <h2>Japan Travel Budget Guide: Daily Costs & Expenses</h2>

  <div className={styles.gridTwo}>
  <div className={styles.budget}>
    <h4>Daily Cost Estimate</h4>
    <ul>
      <li><strong>Budget:</strong> $40–$70/day — hostels, street food, local trains.</li>
      <li><strong>Mid-Range:</strong> $80–$150/day — good hotels, mixed dining, occasional Shinkansen.</li>
      <li><strong>Luxury:</strong> $200+/day — premium hotels, fine dining, private tours, long-distance travel.</li>
    </ul>
  </div>

  <div className={styles.budget}>
    <h4>Major Expenses to Consider</h4>
    <ul>
      <li><strong>Transport:</strong> Shinkansen, local trains, buses, taxis — JR Pass recommended for long-distance.</li>
      <li><strong>Food:</strong> Street snacks to Michelin dining — options for every budget.</li>
      <li><strong>Accommodation:</strong> Capsule hotels, ryokans, mid-range hotels, luxury stays.</li>
      <li><strong>Activities:</strong> Entry tickets for temples, museums, theme parks, and seasonal attractions.</li>
    </ul>
  </div>
</div>

<hr/>
  <p>
    Planning your Japan travel budget helps you maximize experiences while managing costs. With options for every traveler, from budget backpackers to luxury seekers, Japan is accessible and unforgettable.
  </p>
</section>


        <section id="itineraries" className={styles.block}>
  <h2>Suggested Japan Itineraries</h2>
  
<article>
  <h4>5-Day Japan Itinerary</h4>
  <ul>
    <li>
      <strong>Tokyo (3 days):</strong> Explore Shibuya, Shinjuku, Asakusa, and Akihabara. 
      Take a day trip to scenic Nikko or the hot-spring town Hakone.
    </li>
    <li>
      <strong>Osaka (1 day/night):</strong> Try Dotonbori street food, visit Osaka Castle, 
      and enjoy Universal Studios Japan if time allows.
    </li>
  </ul>
</article>

<article>
  <h4>7-Day Japan Itinerary</h4>
  <ul>
    <li>
      <strong>Tokyo (3 days):</strong> Urban exploration, cultural sites, shopping, 
      and entertainment.
    </li>
    <li>
      <strong>Kyoto (2 days):</strong> Famous temples, geisha districts, bamboo forests, 
      and traditional gardens.
    </li>
    <li>
      <strong>Nara (day trip):</strong> Visit Todai-ji Temple, Nara Park, and feed the friendly deer.
    </li>
    <li>
      <strong>Osaka (1 day):</strong> Culinary hotspots, nightlife, and shopping districts.
    </li>
  </ul>
</article>

<article>
  <h4>10-Day Japan Itinerary</h4>
  <ul>
    <li><strong>Tokyo:</strong> Modern attractions, culture, and shopping.</li>
    <li><strong>Hakone / Mt. Fuji:</strong> Hot springs, lake views, and Mt. Fuji scenery.</li>
    <li><strong>Kyoto:</strong> Heritage temples, shrines, and traditional streets.</li>
    <li><strong>Nara:</strong> Ancient temples and deer park.</li>
    <li><strong>Osaka:</strong> Food capital and nightlife.</li>
    <li><strong>Hiroshima:</strong> Peace Memorial Park and Miyajima Island tour.</li>
  </ul>
</article>

<article>
  <h4>Tips for Families, Couples & Solo Travelers</h4>
  <ul>
    <li>
      <strong>Families:</strong> Keep a relaxed schedule and visit kid-friendly attractions 
      like theme parks, aquariums, and interactive museums.
    </li>
    <li>
      <strong>Couples:</strong> Choose romantic activities — cherry blossom walks, sunset spots, 
      scenic trains, and private onsens.
    </li>
    <li>
      <strong>Solo Travelers:</strong> Stay in capsule hotels, plan simple transport routes, 
      and explore safe, vibrant districts at your own pace.
    </li>
  </ul>
</article>

  <p>
    These suggested itineraries help travelers plan a memorable Japan trip, balancing culture, nature, food, and modern attractions while catering to different travel styles and durations.
  </p>
</section>


         
<section id="anime" className={styles.block}>
  <h2>Anime & Pop Culture Experiences in Japan</h2>
  <div className={styles.carousel}>
    {animeImages.map((item, i) => (
      <img
        key={item.id}
        src={item.img}
        alt={item.alt}
        className={`${styles.slide} ${slide === i ? styles.active : ""}`}
      />
    ))}
  </div>

  <ul className={styles.animeList}>
    <li>
      <strong>Akihabara, Tokyo:</strong> The ultimate hub for anime, manga, electronics, and gaming arcades. Explore themed shops, collectible stores, and immersive experiences for pop culture enthusiasts.
    </li>

    <li>
      <strong>Ghibli Museum, Mitaka:</strong> A must-visit for Studio Ghibli fans. Pre-book tickets to step into the magical world of Totoro, Spirited Away, and other beloved classics.
    </li>

    <li>
      <strong>Themed Cafés & Shops:</strong> Discover anime and game-inspired cafés, character pop-up stores, and specialty shops in Tokyo and Osaka for unique, interactive experiences.
    </li>

    <li>
      <strong>Anime Events & Exhibitions:</strong> Attend seasonal anime expos, cosplay events, and limited-time exhibitions to fully immerse yourself in Japan’s vibrant pop culture scene.
    </li>
  </ul>

  <p>
    From iconic districts to immersive museums and themed cafés, Japan offers endless anime and pop culture experiences for fans of all ages, making it a must-visit destination for enthusiasts worldwide.
  </p>
</section>

        

        <section id="why-us" className={styles.block}>
  <h2>Why Book With Atlas Travel House for Your Japan Trip</h2>
  <ul>
    <li>
      <strong>Personalized Itineraries:</strong> We create fully customized Japan travel plans based on your interests, pace, and preferred experiences — from cultural exploration to modern attractions.
    </li>
    <li>
      <strong>24/7 Support & Local Guides:</strong> Enjoy peace of mind with round-the-clock assistance and expert local guides who ensure you make the most of every destination.
    </li>
    <li>
      <strong>Seamless Travel Experience:</strong> We handle visa assistance, airport transfers, accommodations, and transportation logistics so you can focus on enjoying your journey stress-free.
    </li>
    <li>
      <strong>Insider Knowledge & Exclusive Access:</strong> Gain unique insights, skip-the-line options, and exclusive experiences that only a local expert can provide.
    </li>
    <li>
      <strong>Flexible Packages for Every Traveler:</strong> Whether you’re traveling solo, with family, or as a couple, we design itineraries to suit your travel style, budget, and schedule.
    </li>
  </ul>
  <p>
    Booking with Atlas Travel House ensures a memorable, hassle-free Japan adventure tailored just for you — combining convenience, cultural immersion, and unforgettable experiences.
  </p>
</section>

       <section id="faq" className={styles.faqBlock}>
  <div className={styles.faqSection}>
    {/* <FAQSection data={faqData} /> */}
  </div>

  <div className={styles.promoSection}>
    <PromoSidebar offers={promoOffers} />
  </div>
</section>


          <section className={styles.block} aria-label="gallery">
            <div className={styles.galleryGrid}>
              {[gallery1,cars4, gallery3, gallery4, gallery5,cars2, gallery6, gallery7, gallery8,cars3, gallery9,cars1 ].map((g, i) => (
                <img key={i} src={g} alt={`gallery-${i}`} className={styles.galleryImg} />
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* <CTASection
        heading="Ready to Plan Your Japan Trip?"
        description="Contact us to build a custom itinerary — we’ll handle hotels, trains and local guides."
        buttonText="Plan My Trip"
        buttonLink="tel:+919876543210"
      /> */}

      <BlogNavigator category="Travelinternational" blogs={travelBlogs} currentBlogId="japan-full-blog" />
      {/* <FooterBottom /> */}
    </article>
  );
}
